import { render, staticRenderFns } from "./WebsiteMenus.vue?vue&type=template&id=5b82ff02&scoped=true&"
import script from "./WebsiteMenus.vue?vue&type=script&lang=js&"
export * from "./WebsiteMenus.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteMenus.vue?vue&type=style&index=0&id=5b82ff02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82ff02",
  null
  
)

export default component.exports